import { AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Validators, FormGroup, FormControl } from '@angular/forms';

import { countries } from 'src/app/resources/countries';
import { FormModel } from 'src/app/models/form.model';

import { SelectEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TipoFerramenta } from 'src/app/models/tipoferramenta.model';
import { SubTipoFerramenta } from 'src/app/models/subtipoferramenta.model';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { IntlService } from '@progress/kendo-angular-intl';
import { ApiService } from 'src/app/services/http/api.service';
import { BaseHttpResponse, BaseHttpResult } from 'src/app/models/base-http-response';

@Component({
    selector: 'app-tools-subtype-form-component',
    templateUrl: './tools-subtype-form.component.html'
})
export class ToolSubTypeFormComponent extends DialogContentBase  implements OnInit {
    @ViewChild("container", { read: ViewContainerRef })
    public container: ViewContainerRef | undefined;
    public formGroup: FormGroup = new FormGroup({});

    public listItemsTiposFerrramenta: Array<TipoFerramenta> =[];
    public formValue: SubTipoFerramenta  = {
        id: 0,
        marca: '',
        modelo: '',
        nomeTipoFerramenta: '',
        refTipoFerramenta: 0,
        descontinuado: false,
        traducoes: [
            { refLingua: 1, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 2, valor: '', descricaoLingua: '', id: 0 },
            { refLingua: 3, valor: '', descricaoLingua: '', id: 0 }
        ],
        descricao: ''
    };

    public customMsgService: CustomMessagesService;

    constructor(public msgService: MessageService, private notificationService: NotificationService,public override dialog: DialogRef,private intl: IntlService,private api: ApiService) {
        super(dialog);
        this.setFormValues();
        this.customMsgService = this.msgService as CustomMessagesService;
        this.placeHolder.nome = this.customMsgService.translate('selecionartag');

        this.api
        .getRequest<BaseHttpResponse<TipoFerramenta[]>>("TipoFerramentas/GetTiposDeFerramentas")
        .then((data) => {
            this.listItemsTiposFerrramenta = data.value;
          
        })
        .catch((err) => {});
    }
    ngOnInit(): void {
        this.setFormValues();
    }
    public placeHolder: any = {
        nome: "",
        id: undefined,
      };
   

    public setFormValues() {
       

        this.formGroup = new FormGroup({
            marca: new FormControl(this.formValue?.marca, [Validators.required]),
            modelo: new FormControl(this.formValue?.modelo, [Validators.required]),
            refTipoFerramenta: new FormControl(this.formValue.refTipoFerramenta !=0 ? this.formValue.refTipoFerramenta : undefined,[Validators.required] ),
            descontinuado: new FormControl(this.formValue?.descontinuado),
          
        });
    }

  

    public saveChanges(): void {
        this.formGroup.markAllAsTouched();

 this.formValue.descontinuado = this.formGroup.controls['descontinuado'].value;
 this.formValue.marca = this.formGroup.controls['marca'].value;
 this.formValue.modelo = this.formGroup.controls['modelo'].value;
 this.formValue.refTipoFerramenta = this.formGroup.controls['refTipoFerramenta'].value;
        
        this.api.save<BaseHttpResult>('SubTipoFerramenta/SaveSubTipoFerramenta',this.formValue).then(res => {
            if (res.ok) {
               
               
    
            this.notificationService.show({
                content:this.customMsgService.translate('registoGravadoComSucesso') ,
                animation: { type: 'slide', duration: 500 },
                position: { horizontal: 'center', vertical: 'bottom' },
                type: { style: 'success', icon: true },
                hideAfter: 2000
            });
            this.dialog.close();
            } else {
            //   const sb = this.snackBar.open(res.message, "Fechar", {
            //     verticalPosition: "top",
            //     panelClass: ["red-snackbar"],
            //   });
            }
          });
    }

    public cancelChanges(): void {
        this.setFormValues();
    }

  
   

   
}
